import React from 'react';

// Icon-only button (handoff bundle's core/IconButton). `label` is mandatory —
// it is the accessible name and the hover tooltip.

type Variant = 'ghost' | 'solid' | 'primary';
type Size = 'sm' | 'md';

const VARIANT: Record<Variant, string> = {
  ghost: 'text-slate-500 hover:bg-slate-100 hover:text-slate-800',
  solid:
    'border border-slate-300 bg-card text-slate-600 hover:bg-slate-100 hover:text-slate-800',
  primary: 'bg-blue-600 text-white hover:bg-blue-700',
};

const SIZE: Record<Size, string> = {
  sm: 'h-7 w-7',
  md: 'h-8 w-8',
};

export interface IconButtonProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'aria-label' | 'title'> {
  /** Accessible name + tooltip. Required. */
  label: string;
  icon: React.ReactNode;
  variant?: Variant;
  size?: Size;
  /** Selected/toggled state: brand wash. */
  active?: boolean;
}

export function IconButton({
  label,
  icon,
  variant = 'ghost',
  size = 'md',
  active = false,
  className,
  type = 'button',
  ...rest
}: IconButtonProps) {
  return (
    <button
      type={type}
      aria-label={label}
      title={label}
      className={[
        'inline-flex shrink-0 items-center justify-center rounded',
        'transition duration-150 ease-out active:scale-[0.92]',
        'disabled:pointer-events-none disabled:opacity-50',
        active ? 'bg-blue-50 text-blue-700' : VARIANT[variant],
        SIZE[size],
        className ?? '',
      ].join(' ')}
      {...rest}
    >
      {icon}
    </button>
  );
}
